<template>
  <div
    class="image-item"
    :class="{
      'is-deleted': attachment.deleted
    }"
  >
    <div
      v-if="blobUrl && !attachment.deleted"
      class="attachment-component__link"
      :tabindex="-1"
      :data-fancybox="fancyboxData"
      :data-caption="attachment.name"
      :data-file-metadata-id="fileMetadataId || null"
      :data-load-full-size="loadFullSize ? 'true' : null"
      :href="blobUrl"
    >
      <img
        class="attachment-component__img"
        :src="blobUrl"
        :alt="attachment.name"
        style="user-select: none"
      />
    </div>
    <div
      v-else-if="attachment.deleted"
      class="image-item_deleted"
    >
      <div class="image-item_deleted__name-wrapper">
        <div class="custom-file-simplified__icon">
          <icon
            data="@icon/image-not-found.svg"
            width="var(--icon-24)"
            height="var(--icon-24)"
            color="var(--monochrome05to04)"
          />
        </div>
        <BaseSubHeading
          weight="400"
          class="image-item_deleted__name"
          size="medium"
        >
          {{ attachment.name }}
        </BaseSubHeading>
      </div>
      <BaseSubHeading
        weight="500"
        size="extra-small"
        class="image-item_deleted__info"
        color="monochrome-05"
        darkColor="monochrome-04"
      >
        Deleted by {{ attachment.deletedBy?.fullName }}
      </BaseSubHeading>
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseSubHeading from "@/components/Base/BaseSubHeading.vue"

import { FileMetaData } from "@/models"

withDefaults(
  defineProps<{
    attachment: FileMetaData
    fancyboxData?: string
    blobUrl: string
    fileMetadataId?: string | null
    loadFullSize?: boolean
  }>(),
  {
    fancyboxData: "fancybox",
    fileMetadataId: null,
    loadFullSize: false
  }
)
</script>
